import { useState, useCallback } from "react";

const useCompany = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const API_BASE_URL = process.env.REACT_APP_API_URL;
    const accessToken = localStorage.getItem("accessToken");

    const fetchData = useCallback(async (url, options = {}) => {
        setLoading(true);
        setError(null);

        try {
            const response = await fetch(url, {
                headers: { Authorization: `Bearer ${accessToken}`, ...options.headers },
                ...options,
            });

            if (!response.ok) throw new Error(response.statusText);
            return await response.json();
        } catch (err) {
            setError(err.message || "An unexpected error occurred");
            return null;
        } finally {
            setLoading(false);
        }
    }, [accessToken]);

    const fetchCompanies = async (params = {}) => {
        const url = new URL(`${API_BASE_URL}/company`);
        Object.entries(params).forEach(([key, value]) => {
            if (value) url.searchParams.append(key, value);
        });

        const data = await fetchData(url);
        return data?.data;
    };


    const fetchStartupStage = async (name = "") => {
        const url = new URL(`${API_BASE_URL}/auth/lookup/startupStage?page=1&limit=1000`);
        if (name) url.searchParams.append("name", name);
        const data = await fetchData(url);
        return data?.data?.resources;
    };
      const fetchIndustry = async (name = "") => {
        const url = new URL(`${API_BASE_URL}/auth/lookup/industryType?page=1&limit=1000`);
        if (name) url.searchParams.append("name", name);
        const data = await fetchData(url);
        return data?.data?.resources;
    };

    const updateCompany = async (companyId, data) => {
        return await fetchData(`${API_BASE_URL}/company/${companyId}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
            body: JSON.stringify(data),
        });
    };

    const deleteCompany = async (companyId) => {
        return await fetchData(`${API_BASE_URL}/company/${companyId}`, {
            method: "DELETE",
            headers: {
            Authorization: `Bearer ${accessToken}`,
            },
        });
    };

    const handleFileUpload = async (file) => {
        if (!file) return;

        const form = new FormData();
        form.append("file", file);

        const data = await fetchData(`${API_BASE_URL}/media/upload`, {
            method: "POST",
            body: form,
        });

        return data?.data?.url;
    
    };

    return {
        loading,
        error,
        fetchCompanies,
        fetchStartupStage,
        fetchIndustry,
        updateCompany,
        deleteCompany,
        handleFileUpload
    };
};

export default useCompany;
